import React, { forwardRef } from 'react'
import styled from 'styled-components'
import { Link, useRouteMatch } from 'react-router-dom'
import { Nav } from 'rsuite'
import { useCongress } from '../../congress/hooks'
import { MD_BREAKPOINT } from '../../breakpoints'

const CustomLink = forwardRef((props, ref) => {
  const { to, as, ...rest } = props
  return (
    <Link to={to} as={as} {...rest}/>
  )
})

export default function MenuItem ({ children, to, exact, ...rest }) {
  const { congress } = useCongress()

  const match = useRouteMatch({
    path: to,
    exact: exact
  })

  return (
    <Item activecolor={congress.PrimaryColor} componentClass={CustomLink} active={!!match} to={to} {...rest}>
      {children}
    </Item>
  )
}

const Item = styled(Nav.Item)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 1.5rem;
  
  img {
    margin-right: 1rem;
  }
  
  &.rs-nav-item-active .rs-nav-item-content {
    color: ${props => props.activecolor} !important;
  }
  
  @media screen and (max-width: ${MD_BREAKPOINT}em) {
    margin: 0 0.5rem;
    &.rs-nav-item-active .rs-nav-item-content {
      font-size: 1.4rem;
    }
  }
  
  
`